import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles(theme => ({
  text: {
    color: theme.questionColor,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
  },
  routerDebugInfo: {
    display: 'block',
    opacity: '0.1',
    textAlign: 'center',
  },
}));

export default useStyles;
